import React from "react";
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";

import Signin from "../Tuning/Pages/Authentication/Signin";
import Signup from "../Tuning/Pages/Authentication/Signup";
import PasswordReset from "../Tuning/Pages/Authentication/PasswordReset";
import TwoStep from "../Tuning/Pages/Authentication/TwoStep";
import Lockscreen from "../Tuning/Pages/Authentication/Lockscreen";
import Maintenance from "../Tuning/Pages/Authentication/Maintenance";
import NoPageFound from "../Tuning/Pages/Authentication/NoPageFound";
import SigninHrms from "../Tuning/Pages/Authentication/SigninHrms";

const AuthLayout = () => {
  const location = useLocation();
  const pathname = location.pathname;

  const authTitleMapping = {
    "/signin": "Signin",
    "/hrms/login": "SigninHrms",
    "/signup": "Signup",
    "/password-reset": "PasswordReset",
    "/two-step": "TwoStep",
    "/lockscreen": "Lockscreen",
    "/maintenance": "Maintenance",
    "/404": "NoPage",
  };
  const authTitle = authTitleMapping[pathname] || "";

  const authComponents = {
    Signin: <Signin />,
    SigninHrms: <SigninHrms />,
    Signup: <Signup />,
    PasswordReset: <PasswordReset />,
    TwoStep: <TwoStep />,
    Lockscreen: <Lockscreen />,
    Maintenance: <Maintenance />,
    NoPage: <NoPageFound />,
  };

  return (
    <div data-ha="theme-PurpleHeart" className="svgstroke-a auth bg-gradient">
      <main className="container-fluid px-0">
       
        <img src="/images/old-logo.png" alt="jtdc-logo" style={{width:'250px',marginTop:'20px'}}/>
        <div className="px-xl-5 px-4 auth-header" data-bs-theme="none">
          <Link
            to="/index"
            className="brand-icon text-decoration-none d-flex align-items-center"
            title="JTDCL"
          >
            <h2 className="fw-bold ps-2 text-gradient text-center">
              Jharkhand Tourism Development <br />
              <span className="d-block">Corporation Ltd.</span>
            </h2>
          </Link>
        </div>

        {/* <!-- start: page body area --> */}
        {authComponents[authTitle]}

        {/* <!-- start: page footer --> */}
        <footer className="px-xl-5 px-4">
          <p className="mb-0 text-muted" style={{marginTop:'-20px'}}>
            © 2025{" "}
            <a href="https://jtdcl.jharkhand.gov.in" target="_blank" title="jtdcl" rel="noopener noreferrer">
              JTDCL
            </a>
            , All Rights Reserved.
          </p>
        </footer>
      </main>
    </div>
  );
};

export default AuthLayout;
